import { ErrorMessage as ErrorMessageType } from "services/firebase/auth/errorTranslator";

import { useRedirectOnSignInCallback } from "features/sign-up/hooks";

export type SignInCardCommonProps = {
  redirectAuthenticatedUserTo?: string;
  prefilledEmail?: string;
  loading?: boolean;
  headerMessage?: string;
  errorMessage: ErrorMessageType | undefined;
  action: "Log in" | "Sign up";
  children: (props: RenderSignInFormProps) => JSX.Element;
  setErrorMessage: (errorMessage?: ErrorMessageType) => void;
  onSignInSuccess?: () => void;
};

export type RenderSignInFormProps = Omit<SignInCardCommonProps, "children">;

export default function SignInCardCommon({
  children,
  ...props
}: SignInCardCommonProps) {
  const { redirectAuthenticatedUserTo, onSignInSuccess } = props;

  const onSignInSuccessRedirect = useRedirectOnSignInCallback(
    redirectAuthenticatedUserTo
  );

  const renderProps = {
    ...props,
    onSignInSuccess: onSignInSuccess ?? onSignInSuccessRedirect
  };

  return <>{children(renderProps)}</>;
}
